export const CSRF_COOKIE = 'csrf_token';
export const CSRF_HEADER = 'X-CSRF-Token';

export function readCookie(name: string, cookieSource?: string): string | null {
  const source = cookieSource ?? (typeof document !== 'undefined' ? document.cookie : '');
  if (!source) return null;
  const parts = source.split(';');
  for (const part of parts) {
    const idx = part.indexOf('=');
    if (idx <= 0) continue;
    const key = part.slice(0, idx).trim();
    if (key !== name) continue;
    try {
      return decodeURIComponent(part.slice(idx + 1).trim());
    } catch {
      return part.slice(idx + 1).trim();
    }
  }
  return null;
}

export function hasCsrfCookie(cookieSource?: string): boolean {
  return Boolean(readCookie(CSRF_COOKIE, cookieSource));
}

export function authorizationHeader(accessToken: string | null | undefined): string | undefined {
  return accessToken ? `Bearer ${accessToken}` : undefined;
}

export function shouldAttemptRefresh(opts: {
  status: number;
  code?: string;
  retried: boolean;
  authFree: boolean;
  hasCsrfCookie: boolean;
}): boolean {
  void opts.code;
  if (opts.retried || opts.authFree || !opts.hasCsrfCookie) return false;
  return opts.status === 401;
}
